import React, { createContext, FC, ReactNode, useContext, useMemo, useState } from "react"

interface ICodeContext {
  code?: string
  setCode?: React.Dispatch<React.SetStateAction<string | undefined>>
}

interface IProps {
  children: ReactNode
}

const defaultValues: ICodeContext = {}
export const CodeContext = createContext<ICodeContext>(defaultValues)

const CodeProvider: FC<IProps> = ({ children }) => {
  const [code, setCode] = useState<string | undefined>(defaultValues.code)

  const contextValue: ICodeContext = useMemo(
    () => ({
      code,
      setCode,
    }),
    [code],
  )

  return <CodeContext.Provider value={contextValue}>{children}</CodeContext.Provider>
}

export const useCode = () => useContext(CodeContext)

export default CodeProvider
